import React from 'react';

export default function ProductsTable({ items = [] }) {
  return (
    <div className="bg-white rounded-2xl p-4 border">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-gray-500">
            <th className="py-2">#</th>
            <th>Item</th>
            <th>Qtd.</th>
            <th>Valor unit.</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {items.map(it => (
            <tr key={it.id} className="border-t">
              <td className="py-3">{it.id}</td>
              <td>
                <div className="font-medium">{it.title}</div>
                <div className="text-xs text-gray-500">{it.desc}</div>
              </td>
              <td>{it.qty}</td>
              <td>R$ {it.unit.toLocaleString('pt-BR')}</td>
              <td>R$ {it.total.toLocaleString('pt-BR')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
